import React, { useEffect, useState } from "react";
import { Offcanvas, Form, Collapse } from "react-bootstrap";

import { DoneOutlined } from "@mui/icons-material";
import RecursoGallery from "../../components/pgi/RecursoGallery";
import useImage from "../../hooks/useImage";
import Gallery from "../../components/gallery/Gallery";
import useProduct from "../../hooks/useProduct";

const GaleriaPgi = ({
  editProduct,
  setEditProduct,
  modalFor,
  stepId,
  handleCloseGaleria,
}) => {
  const [showEditGaleria, setShowEditGaleria] = useState(false);
  const handleClose = () => setShowEditGaleria(false);
  const handleShow = () => setShowEditGaleria(true);
  const [open, setOpen] = useState(true);
  const [openProducts, setOpenProducts] = useState(false);
  const [openAlbums, setOpenAlbums] = useState(false);

  const { images, setImages, getImagesByBody, filteredImages, setFilteredImages, eliminarCategoriaDuplicados } = useImage();
  const { products } = useProduct();
  const [selectedImage, setSelectedImage] = useState(null);
  const [multiSelect, setMultiSelect] = useState([]);
  const [filterArray, setFilterArray] = useState([]);

  const [albumes, setAlbumes] = useState([]);
  const [albumSelected, setAlbumSelected] = useState([]);

  const handleImageEdit = ({ target }) => {
    setSelectedImage(...images.filter((image) => image.src === target.src));
    handleShow();
  };

  const handleAlbumFilter = ({ target }, album) => {
    const { value, checked } = target;

    if (checked) {
      setFilterArray([...filterArray, value]);
    } else {
      setFilterArray(filterArray.filter((item) => item !== value));
    }

    if (album === "album") {
      setAlbumSelected(
        images
          .map((image) =>
            image.album.includes(value) ? { _id: image.id } : null
          )
          .filter((item) => item !== null)
      );
    } else {
      setAlbumSelected([]);
    }
  };

  useEffect(() => {
    albumSelected.forEach((image) => {
      const img = images.find((img) => img.id === image._id);
      if (!img.isSelected) {
        img.isSelected = true;
        setEditProduct({ ...editProduct, imageGallery: albumSelected });
      }
    });
  }, [albumSelected, editProduct, images, setEditProduct]);

  useEffect(() => {
    if (filterArray.length > 0) {
      const data = images
        .filter(
          (data) =>
            filterArray.includes(data.product) ||
            filterArray.includes(data.category) ||
            data.album.some((item) => filterArray.includes(item))
        )
        .map((filtered) => {
          return filtered;
        });
      setFilteredImages(
        data.sort((a, b) => Number(b.isSelected) - Number(a.isSelected))
      );
    } else {
      const data2 = images;
      setFilteredImages(
        data2.sort((a, b) => Number(b.isSelected) - Number(a.isSelected))
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterArray]);

  const switchModalFor = (res) => {
    switch (modalFor) {
      case "album":
        return editProduct.imageGallery
          .map((item) => item._id)
          .includes(res.id);
      case "icono":
        return editProduct.imageIcon.map((item) => item._id).includes(res.id);
      case "icono-color":
        return editProduct.imageIconColor
          .map((item) => item._id)
          .includes(res.id);
      case "logotipo":
        return editProduct.imageLogo.map((item) => item._id).includes(res.id);
      case "logotipo-color":
        return editProduct.imageLogoColor
          .map((item) => item._id)
          .includes(res.id);
      case "fondo":
        return editProduct.imageBackground
          .map((item) => item._id)
          .includes(res.id);
      case "fondo_tablet":
        return editProduct.imageBackground_tablet
          .map((item) => item._id)
          .includes(res.id);
      case "fondo_mobile":
        return editProduct.imageBackground_mobile
          .map((item) => item._id)
          .includes(res.id);
      case "imagen_producto":
        return editProduct.imageProduct
          .map((item) => item._id)
          .includes(res.id);
      case "imagen_producto_webp":
        return editProduct.imageProduct_webp
          .map((item) => item._id)
          .includes(res.id);
      case "imagen_producto-alpha":
        return editProduct.imageProductAlpha
          .map((item) => item._id)
          .includes(res.id);
      case "imagen_carousel":
        return editProduct.imageCarousel
          .map((item) => item._id)
          .includes(res.id);
      case "imagen_carousel_hover":
        return editProduct.imageCarouselHover
          .map((item) => item._id)
          .includes(res.id);
      case "image_desktop":
        return editProduct?.image_desktop
          ?.map((item) => item._id)
          .includes(res.id);
      case "image_mobile":
        return editProduct?.image_mobile
          ?.map((item) => item._id)
          .includes(res.id);
      case "image_tablet":
        return editProduct?.image_tablet
          ?.map((item) => item._id)
          .includes(res.id);
      case "imageCover":
        return editProduct.imageCover.map((item) => item._id).includes(res.id);
      case "imageCover_tablet":
        return editProduct.imageCover_tablet
          .map((item) => item._id)
          .includes(res.id);
      case "imageCover_mobile":
        return editProduct.imageCover_mobile
          .map((item) => item._id)
          .includes(res.id);
      case "imageBody":
        return editProduct.imageBody.map((item) => item._id).includes(res.id);
      case "instalationSteps":
        const array = editProduct.instalationSteps.map((item) => {
          return item._id === stepId ? item : null;
        });
        return array
          .map((item, index) => item && item.imageInstallation[0])
          .map((image) => image && image._id)
          .includes(res.id);
      case "imageMultimedia":
        return editProduct?.imageMultimedia
          ?.map((item) => item._id)
          .includes(res.id);

      case "imageBusiness":
        return editProduct.imageBusiness
          .map((item) => item._id)
          .includes(res.id);
      case "imageBusiness_tablet":
        return editProduct.imageBusiness_tablet
          .map((item) => item._id)
          .includes(res.id);
      case "imageBusiness_mobile":
        return editProduct.imageBusiness_mobile
          .map((item) => item._id)
          .includes(res.id);
      case "imageBloqueBusiness":
        return editProduct.imageBloqueBusiness
          .map((item) => item._id)
          .includes(res.id);
      case "imageBloqueBusiness_tablet":
        return editProduct.imageBloqueBusiness_tablet
          .map((item) => item._id)
          .includes(res.id);
      case "imageBloqueBusiness_mobile":
        return editProduct.imageBloqueBusiness_mobile
          .map((item) => item._id)
          .includes(res.id);

      case "sliderSecondary":
        const arrayNew = editProduct.sliderSecondary.map((item) => {
          return item._id === stepId ? item : null;
        });
        return arrayNew
          .map((item, index) => item && item.imageSliderBusiness[0])
          .map((image) => image && image._id)
          .includes(res.id);

      case "t21":
        const arrayT21 = editProduct.t21.map((item) => {
          return item._id === stepId ? item : null;
        });
        return arrayT21
          .map((item, index) => item && item.imageCover[0])
          .map((image) => image && image._id)
          .includes(res.id);

      case "t21_mobile":
        const arrayT21Mobile = editProduct.t21.map((item) => {
          return item._id === stepId ? item : null;
        });
        return arrayT21Mobile
          .map((item, index) => item && item.imageCover_mobile[0])
          .map((image) => image && image._id)
          .includes(res.id);

      case "t180":
        const arrayT180 = editProduct.t180.map((item) => {
          return item._id === stepId ? item : null;
        });
        return arrayT180
          .map((item, index) => item && item.imageCover[0])
          .map((image) => image && image._id)
          .includes(res.id);

      case "t180_mobile":
        const arrayT180Mobile = editProduct.t180.map((item) => {
          return item._id === stepId ? item : null;
        });
        return arrayT180Mobile
          .map((item, index) => item && item.imageCover_mobile[0])
          .map((image) => image && image._id)
          .includes(res.id);

      default:
    }
  };

  useEffect(() => {
    getImagesByBody().then((res) => {
      const mapeo = res?.map((res) => {
        return {
          src: res.url,
          thumbnail: res.url,
          thumbnailWidth: 320,
          thumbnailHeight: 212,
          caption: res.name,
          alt: res.alt,
          id: res.id,
          title: res.title,
          description: res.description,
          category: res.category,
          product: res.product,
          tags: res.tags
            ? res.tags.map((item) => {
                return {
                  value: item,
                  title: item,
                };
              })
            : [],
          album: res.album,
          isSelected: switchModalFor(res),
        };
      });
      setImages(mapeo);
      setFilteredImages(
        mapeo?.sort((a, b) => Number(b.isSelected) - Number(a.isSelected))
      );
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setMultiSelect(
      filteredImages?.filter(
        (item) => item?.isSelected === true)
      );
  }, [filteredImages])

  useEffect(() => {
    let albumes = [];
    let array = [];

    images.map((image) => {
      if (image.album !== undefined) {
        image.album.map((album) => {
          albumes.push(album);
          return albumes;
        });
      }
      return image;
    });
    array = [...new Set(albumes)];
    setAlbumes(array);
  }, [images]);

  const onSelectImage = (index, image) => {
    const img = images.find((img) => img.id === image.id);
    if (img.isSelected) {
      img.isSelected = false;
      setMultiSelect(
        multiSelect.filter(
          (item) => item !== multiSelect.find((obj) => obj.id === image.id)
          )
          );
      switch (modalFor) {
        case "album":
          setEditProduct({
            ...editProduct,
            imageGallery: editProduct.imageGallery.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "logotipo":
          setEditProduct({
            ...editProduct,
            imageLogo: editProduct.imageLogo.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "logotipo-color":
          setEditProduct({
            ...editProduct,
            imageLogoColor: editProduct.imageLogoColor.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "icono":
          setEditProduct({
            ...editProduct,
            imageIcon: editProduct.imageIcon.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "icono-color":
          setEditProduct({
            ...editProduct,
            imageIconColor: editProduct.imageIconColor.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "fondo":
          setEditProduct({
            ...editProduct,
            imageBackground: editProduct.imageBackground.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "fondo_tablet":
          setEditProduct({
            ...editProduct,
            imageBackground_tablet: editProduct.imageBackground_tablet.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "fondo_mobile":
          setEditProduct({
            ...editProduct,
            imageBackground_mobile: editProduct.imageBackground_mobile.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imagen_producto":
          setEditProduct({
            ...editProduct,
            imageProduct: editProduct.imageProduct.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imagen_producto_webp":
          setEditProduct({
            ...editProduct,
            imageProduct_webp: editProduct.imageProduct_webp.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imagen_producto-alpha":
          setEditProduct({
            ...editProduct,
            imageProductAlpha: editProduct.imageProductAlpha.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imagen_carousel":
          setEditProduct({
            ...editProduct,
            imageCarousel: editProduct.imageCarousel.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imagen_carousel_hover":
          setEditProduct({
            ...editProduct,
            imageCarouselHover: editProduct.imageCarouselHover.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "image_desktop":
          setEditProduct({
            ...editProduct,
            image_desktop: editProduct.image_desktop.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "image_mobile":
          setEditProduct({
            ...editProduct,
            image_mobile: editProduct.image_mobile.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "image_tablet":
          setEditProduct({
            ...editProduct,
            image_tablet: editProduct.image_tablet.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imageCover":
          setEditProduct({
            ...editProduct,
            imageCover: editProduct.imageCover.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imageCover_tablet":
          setEditProduct({
            ...editProduct,
            imageCover_tablet: editProduct.imageCover_tablet.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imageCover_mobile":
          setEditProduct({
            ...editProduct,
            imageCover_mobile: editProduct.imageCover_mobile.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imageBody":
          setEditProduct({
            ...editProduct,
            imageBody: editProduct.imageBody.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imageBusiness":
          setEditProduct({
            ...editProduct,
            imageBusiness: editProduct.imageBusiness.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imageBusiness_tablet":
          setEditProduct({
            ...editProduct,
            imageBusiness_tablet: editProduct.imageBusiness_tablet.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imageBusiness_mobile":
          setEditProduct({
            ...editProduct,
            imageBusiness_mobile: editProduct.imageBusiness_mobile.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imageBloqueBusiness":
          setEditProduct({
            ...editProduct,
            imageBloqueBusiness: editProduct.imageBloqueBusiness.filter(
              (img) => img._id !== image.id
            ),
          });
          break;
        case "imageBloqueBusiness_tablet":
          setEditProduct({
            ...editProduct,
            imageBloqueBusiness_tablet:
              editProduct.imageBloqueBusiness_tablet.filter(
                (img) => img._id !== image.id
              ),
          });
          break;
        case "imageBloqueBusiness_mobile":
          setEditProduct({
            ...editProduct,
            imageBloqueBusiness_mobile:
              editProduct.imageBloqueBusiness_mobile.filter(
                (img) => img._id !== image.id
              ),
          });
          break;
        case "sliderSecondary":
          setEditProduct({
            ...editProduct,
            sliderSecondary: editProduct.sliderSecondary.map((step) =>
              step._id === stepId
                ? {
                    ...step,
                    imageSliderBusiness: step.imageSliderBusiness.filter(
                      (img) => img._id !== image.id
                    ),
                  }
                : step
            ),
          });
          break;
        case "instalationSteps":
          setEditProduct({
            ...editProduct,
            instalationSteps: editProduct.instalationSteps.map((step) =>
              step._id === stepId
                ? {
                    ...step,
                    imageInstallation: step.imageInstallation.filter(
                      (img) => img._id !== image.id
                    ),
                  }
                : step
            ),
          });
          break;
          case "imageMultimedia":
            setEditProduct({
              ...editProduct,
              imageMultimedia: editProduct.imageMultimedia.filter(
                (img) => img._id !== image.id
              ),
            });
            break;
        case "t21":
          setEditProduct({
            ...editProduct,
            t21: editProduct.t21.map((step) =>
              step._id === stepId
                ? {
                    ...step,
                    imageCover: step.imageCover.filter(
                      (img) => img._id !== image.id
                    ),
                  }
                : step
            ),
          });

          break;

        case "t21_mobile":
          setEditProduct({
            ...editProduct,
            t21: editProduct.t21.map((step) =>
              step._id === stepId
                ? {
                    ...step,
                    imageCover_mobile: step.imageCover_mobile.filter(
                      (img) => img._id !== image.id
                    ),
                  }
                : step
            ),
          });
          break;

        case "t180":
          setEditProduct({
            ...editProduct,
            t180: editProduct.t180.map((step) =>
              step._id === stepId
                ? {
                    ...step,
                    imageCover: step.imageCover.filter(
                      (img) => img._id !== image.id
                    ),
                  }
                : step
            ),
          });

          break;

        case "t180_mobile":
          setEditProduct({
            ...editProduct,
            t180: editProduct.t180.map((step) =>
              step._id === stepId
                ? {
                    ...step,
                    imageCover_mobile: step.imageCover_mobile.filter(
                      (img) => img._id !== image.id
                    ),
                  }
                : step
            ),
          });
          break;
        default:
      }
    } else {
      img.isSelected = true;
      setMultiSelect([...multiSelect, { id: img.id, album: img.album }]);
      switch (modalFor) {
        case "album":
          setEditProduct({
            ...editProduct,
            imageGallery: [...editProduct.imageGallery, { _id: img.id }],
          });
          break;
        case "logotipo":
          setEditProduct({
            ...editProduct,
            imageLogo: [...editProduct.imageLogo, { _id: img.id }],
          });
          break;
        case "logotipo-color":
          setEditProduct({
            ...editProduct,
            imageLogoColor: [...editProduct.imageLogoColor, { _id: img.id }],
          });
          break;
        case "icono":
          setEditProduct({
            ...editProduct,
            imageIcon: [...editProduct.imageIcon, { _id: img.id }],
          });
          break;
        case "icono-color":
          setEditProduct({
            ...editProduct,
            imageIconColor: [...editProduct.imageIconColor, { _id: img.id }],
          });
          break;
        case "fondo":
          setEditProduct({
            ...editProduct,
            imageBackground: [...editProduct.imageBackground, { _id: img.id }],
          });
          break;
        case "fondo_tablet":
          setEditProduct({
            ...editProduct,
            imageBackground_tablet: [
              ...editProduct.imageBackground_tablet,
              { _id: img.id },
            ],
          });
          break;
        case "fondo_mobile":
          setEditProduct({
            ...editProduct,
            imageBackground_mobile: [
              ...editProduct.imageBackground_mobile,
              { _id: img.id },
            ],
          });
          break;
        case "imagen_producto":
          setEditProduct({
            ...editProduct,
            imageProduct: [...editProduct.imageProduct, { _id: img.id }],
          });
          break;
        case "imagen_producto_webp":
          setEditProduct({
            ...editProduct,
            imageProduct_webp: [
              ...editProduct.imageProduct_webp,
              { _id: img.id },
            ],
          });
          break;
        case "imagen_producto-alpha":
          setEditProduct({
            ...editProduct,
            imageProductAlpha: [
              ...editProduct.imageProductAlpha,
              { _id: img.id },
            ],
          });
          break;
        case "imagen_carousel":
          setEditProduct({
            ...editProduct,
            imageCarousel: [...editProduct.imageCarousel, { _id: img.id }],
          });
          break;
        case "imagen_carousel_hover":
          setEditProduct({
            ...editProduct,
            imageCarouselHover: [
              ...editProduct.imageCarouselHover,
              { _id: img.id },
            ],
          });
          break;
        case "image_desktop":
          setEditProduct({
            ...editProduct,
            image_desktop: [...editProduct.image_desktop, { _id: img.id }],
          });
          break;
        case "image_tablet":
          setEditProduct({
            ...editProduct,
            image_tablet: [...editProduct.image_tablet, { _id: img.id }],
          });
          break;
        case "image_mobile":
          setEditProduct({
            ...editProduct,
            image_mobile: [...editProduct.image_mobile, { _id: img.id }],
          });
          break;
        case "imageCover":
          setEditProduct({
            ...editProduct,
            imageCover: [...editProduct.imageCover, { _id: img.id }],
          });
          break;
        case "imageCover_tablet":
          setEditProduct({
            ...editProduct,
            imageCover_tablet: [
              ...editProduct.imageCover_tablet,
              { _id: img.id },
            ],
          });
          break;
        case "imageCover_mobile":
          setEditProduct({
            ...editProduct,
            imageCover_mobile: [
              ...editProduct.imageCover_mobile,
              { _id: img.id },
            ],
          });
          break;
        case "imageBody":
          setEditProduct({
            ...editProduct,
            imageBody: [...editProduct.imageBody, { _id: img.id }],
          });
          break;
        case "imageBusiness":
          setEditProduct({
            ...editProduct,
            imageBusiness: [...editProduct.imageBusiness, { _id: img.id }],
          });
          break;
        case "imageBusiness_tablet":
          setEditProduct({
            ...editProduct,
            imageBusiness_tablet: [
              ...editProduct.imageBusiness_tablet,
              { _id: img.id },
            ],
          });
          break;
        case "imageBusiness_mobile":
          setEditProduct({
            ...editProduct,
            imageBusiness_mobile: [
              ...editProduct.imageBusiness_mobile,
              { _id: img.id },
            ],
          });
          break;
        case "imageBloqueBusiness":
          setEditProduct({
            ...editProduct,
            imageBloqueBusiness: [
              ...editProduct.imageBloqueBusiness,
              { _id: img.id },
            ],
          });
          break;
        case "imageBloqueBusiness_tablet":
          setEditProduct({
            ...editProduct,
            imageBloqueBusiness_tablet: [
              ...editProduct.imageBloqueBusiness_tablet,
              { _id: img.id },
            ],
          });
          break;
        case "imageBloqueBusiness_mobile":
          setEditProduct({
            ...editProduct,
            imageBloqueBusiness_mobile: [
              ...editProduct.imageBloqueBusiness_mobile,
              { _id: img.id },
            ],
          });
          break;
        case "sliderSecondary":
          setEditProduct({
            ...editProduct,
            sliderSecondary: editProduct.sliderSecondary.map((step) => {
              if (step._id === stepId) {
                return {
                  ...step,
                  imageSliderBusiness: [
                    ...step.imageSliderBusiness,
                    { _id: img.id },
                  ],
                };
              } else {
                return step;
              }
            }),
          });
          break;
        case "instalationSteps":
          setEditProduct({
            ...editProduct,
            instalationSteps: editProduct.instalationSteps.map((step) => {
              if (step._id === stepId) {
                return {
                  ...step,
                  imageInstallation: [
                    ...step.imageInstallation,
                    { _id: img.id },
                  ],
                };
              } else {
                return step;
              }
            }),
          });
          break;
          case "imageMultimedia":
            setEditProduct({
              ...editProduct,
              imageMultimedia: [...editProduct.imageMultimedia, { _id: img.id }],
            });
            break;
        case "t21":
          setEditProduct({
            ...editProduct,
            t21: editProduct.t21.map((step) => {
              return {
                ...step,
                imageCover: [...step.imageCover, { _id: img.id }],
              };
            }),
          });
          break;
        case "t21_mobile":
          setEditProduct({
            ...editProduct,
            t21: editProduct.t21.map((step) => {
              return {
                ...step,
                imageCover_mobile: [...step.imageCover_mobile, { _id: img.id }],
              };
            }),
          });
          break;
        case "t180":
          setEditProduct({
            ...editProduct,
            t180: editProduct.t180.map((step) => {
              return {
                ...step,
                imageCover: [...step.imageCover, { _id: img.id }],
              };
            }),
          });
          break;
        case "t180_mobile":
          setEditProduct({
            ...editProduct,
            t180: editProduct.t180.map((step) => {
              return {
                ...step,
                imageCover_mobile: [...step.imageCover_mobile, { _id: img.id }],
              };
            }),
          });
          break;
        default:
      }
    }
  };

  const categoryOptions = eliminarCategoriaDuplicados(images)?.map((item) => item.label);

  return (
    <div id="wrapperEditGaleria" className="wrapperPgi">
      <div className="my-5 container containerPgi">
        <header>
          <h1>Galería Multimedia</h1>
          <button
            type="button"
            onClick={handleCloseGaleria}
            className="btn btn__save"
          >
            GUARDAR <DoneOutlined />
          </button>
        </header>
        <section className="wrapperViewGalery">
          <div id="pgi__galeria-filter">
          <section id="categoryGalery">
              <p
                onClick={() => setOpen(!open)}
                aria-controls="category-collapse"
                aria-expanded={open}
                className="item-galeria-pgi filter-gallery"
              >
                Categorías ({categoryOptions.length})
              </p>
              <Collapse in={open}>
                <div id="category-collapse">
                  {categoryOptions.map((id, index) => (
                    <Form.Check
                      type="checkbox"
                      key={index}
                      id={`id${id}`}
                      label={`${id}`}
                      name={"category"}
                      value={id}
                      checked={filterArray.includes(id)}
                      onChange={handleAlbumFilter}
                    />
                  ))}
                </div>
              </Collapse>
            </section>
            <section id="productsGalery">
            <p
                onClick={() => setOpenProducts(!openProducts)}
                aria-controls="products-collapse"
                aria-expanded={openProducts}
                className="item-galeria-pgi filter-gallery"
              >
                Productos ({products ? products.filter((product) => product.type === "productoLinea" && !product.deleted && product.visible).length : 0})
              </p>
              <Collapse in={openProducts}>
                <div id="products-collapse">
                  <ul>
                    {products?.map(
                      (product, index) =>
                        product?.type === "productoLinea" &&
                        product?.deleted !== true &&
                        product?.visible === true && (
                          <Form.Check
                            type="checkbox"
                            id={`id${product.title}`}
                            key={index}
                            label={`${product.title}`}
                            name={"product"}
                            value={product.title}
                            checked={filterArray.includes(product.title)}
                            onChange={handleAlbumFilter}
                          />
                        )
                    )}
                  </ul>
                </div>
              </Collapse>
            </section>
            <section id="albumesGalery d-flex">
              <p
                onClick={() => setOpenAlbums(!openAlbums)}
                aria-controls="products-collapse"
                aria-expanded={openAlbums}
                className="item-galeria-pgi filter-gallery"
              >
                Álbumes ({albumes.length})
              </p>
              <Collapse in={openAlbums}>
                <div id="products-collapse">
                  <Form>
                    {albumes.map((id, index) => (
                      <Form.Check
                        className="pgi__editAlbum"
                        type="checkbox"
                        id={`id${id}`}
                        key={index}
                        label={`${id}`}
                        name={"album"}
                        value={id}
                        checked={filterArray.includes(id)}
                        onChange={handleAlbumFilter}
                      />
                    ))}
                  </Form>
                </div>
              </Collapse>
            </section>
          </div>
          <div id="pgi__galeria-view">
            <article className="pgi__album-category">
              <h2>
                Todos <i>({filteredImages?.length})</i>
              </h2>
              <Gallery
                filteredImages={filteredImages}
                selectedImages={multiSelect}
                imageCountSeparator=" de "
                enableImageSelection={true}
                onSelectImage={onSelectImage}
                backdropClosesModal={true}
                showLightboxThumbnails={true}
                onClickImage={handleImageEdit}
              />
            </article>
          </div>
        </section>
      </div>
      <Offcanvas
        show={showEditGaleria}
        onHide={handleClose}
        placement="end"
        scroll
        enforceFocus
        backdrop={false}
        className="basePgi__pgi"
      >
        <Offcanvas.Header closeButton>
          <Offcanvas.Title>Información de Recurso</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <RecursoGallery
            selectedImage={selectedImage ? selectedImage : null}
            allImages={images}
          />
        </Offcanvas.Body>
      </Offcanvas>

    </div>
  );
};

export default GaleriaPgi;
